export default __webpack_public_path__ + "static/media/new-calendar-icon.5068e0a1.svg";